export interface IEmail {
    Email: string;
    Nombre?: string;
}

export class Email {
    Email: string;
    Nombre?: string;

    constructor(data?: IEmail) {
        if (data) {
            this.Email = data.Email;
            this.Nombre = data.Nombre;
        }
    }
}

export interface IEmailMessage {
    Emisor?: Email;
    Destinatarios: Email[];
    Asunto: string;
    Mensaje: string;
    CC?: Email[];
    CCO?: Email[];
    Adjunto?: string;
}

export class EmailMessage {
    Emisor?: Email;
    Destinatarios: Email[];
    Asunto: string;
    Mensaje: string;
    CC?: Email[];
    CCO?: Email[];
    Adjunto?: string;

    constructor(data?: IEmailMessage) {
        if (data) {
            this.Emisor = data.Emisor;
            this.Destinatarios = data.Destinatarios;
            this.Asunto = data.Asunto;
            this.Mensaje = data.Mensaje;
            this.CC = data.CC;
            this.CCO = data.CCO;
            this.Adjunto = data.Adjunto;
        }
    }
}

export interface EmailResponse {
    FlagEnviado: boolean;
    Mensaje: string;
    ErrorTecnico: string;
}
